import React from "react";


export default function ResetPasswordSuccess({setKnowsPassword}) {

    return (
        <>
            <div className=" text-lg">Your password has been reset</div>

            <button onClick={() => setKnowsPassword(true)}
                    className="bg-gold-accent hover:bg-gold-accent-hover text-white h-14 px-4 py-2 rounded-lg">
                Log in
            </button>
        </>
    )
}